// Each provider handles one concern and knows only its parent's API, so it
// registers only with its immediate parent. Events flow one way: room socket →
// room state → media → the media managers. UI components reflect that state and
// never control it.

import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import {
  MediaProvider,
  AccountSocketProvider,
  AchievementProvider,
  AuthProvider,
  RoomStateProvider,
  RouteProvider,
  RoomSocketProvider,
} from '../contexts';
import { appQueryClient } from './queryClient';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => (
  <QueryClientProvider client={appQueryClient}>
    <RouteProvider>
      <RoomSocketProvider>
        <AuthProvider>
          <AccountSocketProvider>
            <AchievementProvider>
              <RoomStateProvider>
                <MediaProvider>{children}</MediaProvider>
              </RoomStateProvider>
            </AchievementProvider>
          </AccountSocketProvider>
        </AuthProvider>
      </RoomSocketProvider>
    </RouteProvider>
  </QueryClientProvider>
);
